import { render, staticRenderFns } from "./UpdateNominatedAccount.vue?vue&type=template&id=445b63c8"
import script from "./UpdateNominatedAccount.vue?vue&type=script&lang=js"
export * from "./UpdateNominatedAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports